module.exports = {
    FIRST_BLOCK: '1',
    UPLOAD_FILE_TYPE: 'flat',
    HOLDER_INTERVENTION_TYPE: 'TITULAR',
    HOLDER_ORDER: 1,
    COHOLDER_ORDER: 2,
};
